"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var react_css_themr_1 = require("@vidazoo/react-css-themr");
var utils_1 = require("../utils");
function createFactory(identifier, formFieldTheme) {
    return function factory(WrappedComponent, options) {
        if (options === void 0) { options = {
            labelSpacing: .8
        }; }
        var FormField = /** @class */ (function (_super) {
            tslib_1.__extends(FormField, _super);
            function FormField(props, context) {
                var _this = _super.call(this, props, context) || this;
                _this.onFocus = function (e) {
                    var onFocus = _this.props.onFocus;
                    if (!_this.state.focus) {
                        _this.setState({ focus: true });
                    }
                    onFocus && onFocus(e);
                };
                _this.onBlur = function (e) {
                    var onBlur = _this.props.onBlur;
                    if (_this.state.focus) {
                        _this.setState({ focus: false });
                    }
                    onBlur && onBlur(e);
                };
                _this.onChange = function (e) {
                    var onChange = _this.props.onChange;
                    _this.setValidation();
                    onChange && onChange(e);
                };
                _this.onInvalid = function (e) {
                    var onInvalid = _this.props.onInvalid;
                    e.preventDefault(e);
                    _this.setValidation();
                    onInvalid && onInvalid(e);
                };
                _this.hasWhitespaces = function (value) {
                    var hideWhiteSpacesMessage = _this.props.hideWhiteSpacesMessage;
                    if (hideWhiteSpacesMessage) {
                        return false;
                    }
                    if (value) {
                        return utils_1.hasWhiteSpace(String(value));
                    }
                };
                _this.id = utils_1.guid();
                _this.$input = null;
                _this.state = { valid: true, validationMessage: "", focus: false };
                return _this;
            }
            FormField.prototype.componentDidUpdate = function (prevProps) {
                this.handleValidationOnUpdate(prevProps);
            };
            FormField.prototype.handleValidationOnUpdate = function (prevProps) {
                var triggerValidationProps = this.props.triggerValidationProps;
                if (triggerValidationProps.length) {
                    for (var i = 0, len = triggerValidationProps.length; i < len; i++) {
                        var propName = triggerValidationProps[i];
                        if (prevProps[propName] !== this.props[propName]) {
                            this.setValidation();
                            break;
                        }
                    }
                }
            };
            FormField.prototype.componentWillUnmount = function () {
                var unregisterContextField = this.context.unregisterContextField;
                unregisterContextField && unregisterContextField(this.id);
                this.$input = null;
            };
            FormField.prototype.setValidation = function () {
                var nextValidState = this.$input.validity.valid;
                if (this.state.valid !== nextValidState) {
                    this.setState({
                        valid: nextValidState,
                        validationMessage: this.getValidationMessage()
                    });
                    var setValidationForContextField = this.context.setValidationForContextField;
                    setValidationForContextField && setValidationForContextField(nextValidState, this.id);
                }
            };
            FormField.prototype.getValidationMessage = function () {
                var validationMessages = this.props.validationMessages;
                var inputValidityState = this.$input.validity;
                for (var invalidKey in inputValidityState) {
                    if (invalidKey !== "valid" && inputValidityState[invalidKey]) {
                        return validationMessages[invalidKey] || this.$input.validationMessage;
                    }
                }
                return "";
            };
            FormField.prototype.render = function () {
                var _this = this;
                var _a;
                var _b = this.props, theme = _b.theme, className = _b.className, ignoreInputName = _b.ignoreInputName, name = _b.name, disabled = _b.disabled, required = _b.required, readOnly = _b.readOnly, value = _b.value, defaultValue = _b.defaultValue, onFocus = _b.onFocus, onBlur = _b.onBlur, label = _b.label, info = _b.info, invalid = _b.invalid, hideValidationMessage = _b.hideValidationMessage, floatMessage = _b.floatMessage, validationMessages = _b.validationMessages, fill = _b.fill, triggerValidationProps = _b.triggerValidationProps, hideWhiteSpacesMessage = _b.hideWhiteSpacesMessage, others = tslib_1.__rest(_b, ["theme", "className", "ignoreInputName", "name", "disabled", "required", "readOnly", "value", "defaultValue", "onFocus", "onBlur", "label", "info", "invalid", "hideValidationMessage", "floatMessage", "validationMessages", "fill", "triggerValidationProps", "hideWhiteSpacesMessage"]);
                var _c = this.state, validationMessage = _c.validationMessage, valid = _c.valid, focus = _c.focus;
                var classes = classnames_1.default(theme.field, className, (_a = {},
                    _a[theme.focus] = focus,
                    _a[theme.invalid] = !valid || invalid,
                    _a[theme.fill] = fill,
                    _a[theme.disabled] = disabled,
                    _a[theme.floatMessage] = floatMessage,
                    _a));
                var wrappedComponentProps = tslib_1.__assign({}, others, { className: theme.input, exposedRef: function (el) { return _this.$input = el; }, onFocus: this.onFocus, onBlur: this.onBlur, onChange: this.onChange, onInvalid: this.onInvalid, name: name,
                    fill: fill,
                    disabled: disabled,
                    required: required,
                    readOnly: readOnly,
                    value: value,
                    defaultValue: defaultValue,
                    focus: focus, invalid: !valid || invalid });
                var hasWhiteSpaces = this.hasWhitespaces(value);
                return (React.createElement("div", { className: classes },
                    label ? React.createElement("div", { className: theme.label, style: { marginBottom: utils_1.toREMString(options.labelSpacing) } },
                        label,
                        " ",
                        required ? "*" : null) : null,
                    name && this.context.showInputNames && !ignoreInputName ? React.createElement("div", { className: theme.name },
                        "(",
                        name,
                        ")") : null,
                    React.createElement(WrappedComponent, tslib_1.__assign({}, wrappedComponentProps, { "data-form-field-id": this.id })),
                    (validationMessage || (validationMessages.manual && invalid)) && !hideValidationMessage
                        ? React.createElement("div", { className: theme.validation }, validationMessage || validationMessages.manual)
                        : info
                            ? React.createElement("div", { className: theme.info }, info)
                            : null,
                    hasWhiteSpaces && React.createElement("div", { className: theme.info }, "Attention! Value contains whitespaces.")));
            };
            FormField.defaultProps = {
                disabled: false,
                required: false,
                readOnly: false,
                hideValidationMessage: false,
                validationMessages: {},
                triggerValidationProps: ["value"],
                hideWhiteSpacesMessage: false
            };
            FormField.contextTypes = {
                setValidationForContextField: PropTypes.func,
                unregisterContextField: PropTypes.func,
                showInputNames: PropTypes.bool
            };
            return FormField;
        }(React.Component));
        return react_css_themr_1.themr(identifier, formFieldTheme)(FormField);
    };
}
exports.default = createFactory;
